import { $api } from "@/lib/api";

// Whether this agency has a mailbox connected, and so can send email at all.
// Read as a capability off /users/me — never by asking whether a mail account
// exists — as a technical capability in `features` (`send_email`). Product areas travel as
// abilities; this one is not an area, so it stays in `features`.
//
// An agency without one keeps the whole thread UI: it reads conversations and
// writes internal notes. Only the two affordances that would end in a failed
// send — opening a thread with the client, and replying — are withheld.
//
// Reads the query rather than `useUser()` on purpose: that hook also redirects
// on 403, which drags `useNavigate` (and therefore a router) into every screen
// that renders a conversation. The key is the same, so this is the very same
// cache entry the app already filled — no second request.
//
// It is a snapshot: /users/me is fetched once per session, so a mailbox
// connected (or disconnected) mid-session is not reflected until a refetch.
// That is why the send path still guards server-side and answers
// MAIL_ACCOUNT_NOT_CONFIGURED.
export const useCanSendEmail = (): boolean => {
  const { data: user } = $api.useQuery("get", "/v1/users/me", {});

  return user?.settings?.features?.includes("send_email") ?? false;
};
